export default "__VITE_ASSET__DyiRaD00__"